'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.create = create;

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _strftime = require('strftime');

var _strftime2 = _interopRequireDefault(_strftime);

var _browser = require('irc-framework/browser');

var _browser2 = _interopRequireDefault(_browser);

var _BouncerMiddleware = require('./BouncerMiddleware');

var _BouncerMiddleware2 = _interopRequireDefault(_BouncerMiddleware);

var _ServerConnection = require('./ServerConnection');

var ServerConnection = _interopRequireWildcard(_ServerConnection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function create(state, network) {
    var networkid = network.id;

    var clientOpts = {
        host: network.connection.server,
        port: network.connection.port,
        tls: network.connection.tls,
        path: network.connection.path,
        password: network.connection.password,
        nick: network.nick,
        username: network.username || network.nick,
        gecos: network.gecos || 'https://kiwiirc.com/',
        version: null,
        auto_reconnect: false,
        encoding: network.connection.encoding
    };

    if (!network.connection.direct) {
        clientOpts.transport = ServerConnection.createChannelConstructor(state.settings.kiwiServer, (window.location.hash || '').substr(1), networkid);
    }

    var ircClient = new _browser2.default.Client(clientOpts);
    ircClient.requestCap('znc.in/self-message');
    ircClient.use(clientMiddleware(state, network));
    ircClient.use((0, _BouncerMiddleware2.default)());

    var originalIrcClientConnect = ircClient.connect;
    ircClient.connect = function connect() {
        var bnc = state.setting('bnc');
        if (bnc.active) {
            var netname = network.connection.bncname;
            var password = '';

            if (network.name === 'bnccontrol') {
                password = bnc.username + '/__kiwiauth:' + bnc.password;
            } else {
                password = bnc.username + '/' + netname + ':' + bnc.password;
            }

            ircClient.options.host = bnc.server;
            ircClient.options.port = bnc.port;
            ircClient.options.tls = bnc.tls;
            ircClient.options.password = password;
            ircClient.options.nick = network.nick;
            ircClient.options.username = bnc.username;
            ircClient.options.encoding = network.connection.encoding;
        } else {
            ircClient.options.host = network.connection.server;
            ircClient.options.port = network.connection.port;
            ircClient.options.tls = network.connection.tls;
            ircClient.options.password = network.connection.password;
            ircClient.options.nick = network.nick;
            ircClient.options.username = network.username || network.nick;
            ircClient.options.gecos = network.gecos || 'https://kiwiirc.com/';
            ircClient.options.encoding = network.connection.encoding;
        }

        state.$emit('network.connecting', { network: network });

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        originalIrcClientConnect.apply(ircClient, args);
    };

    ircClient.on('raw', function (event) {
        if (!network.setting('show_raw')) {
            return;
        }

        var buffer = state.getOrAddBufferByName(networkid, '*raw');
        state.addMessage(buffer, {
            time: Date.now(),
            nick: '',
            message: (event.from_server ? '[S] ' : '[C] ') + event.line
        });
    });

    return ircClient;
}

function clientMiddleware(state, network) {
    var networkid = network.id;
    var numConnects = 0;

    var requestedCh = false;

    return function middlewareFn(client, rawEvents, parsedEvents) {
        parsedEvents.use(parsedEventsHandler);
        rawEvents.use(rawEventsHandler);

        client.on('connecting', function () {
            network.state_error = '';
            network.state = 'connecting';
            network.last_error = '';
        });

        client.on('connected', function () {
            network.state_error = '';
            network.state = 'connected';

            network.buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                var messageBody = TextFormatting.formatText('network_connected', {
                    text: TextFormatting.t('connected')
                });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '',
                    message: messageBody,
                    type: 'connection',
                    type_extra: 'connected'
                });
            });
        });

        client.on('socket close', function (err) {
            network.state = 'disconnected';
            network.state_error = err || '';

            network.buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                buffer.joined = false;
                buffer.clearUsers();

                var messageBody = TextFormatting.formatText('network_disconnected', {
                    text: TextFormatting.t('disconnected')
                });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '',
                    message: messageBody,
                    type: 'connection',
                    type_extra: 'disconnected'
                });
            });
        });

        client.on('socket connected', function () {
            if (network.captchaResponse) {
                client.raw('CAPTCHA', network.captchaResponse);
            }
        });
    };

    function rawEventsHandler(command, event, rawLine, client, next) {
        state.$emit('irc.raw', command, event, network);
        state.$emit('irc.raw.' + command, command, event, network);
        next();
    }

    function parsedEventsHandler(command, event, client, next) {
        var ircEventObj = { handled: false };
        state.$emit('irc.' + command, event, network, ircEventObj);
        if (ircEventObj.handled) {
            next();
            return;
        }

        if (event && event.command === 'CONTROL') {
            next();
            return;
        }

        if (command === 'channel_redirect') {
            var b = network.bufferByName(event.from);
            if (b) {
                b.flags.redirect_to = event.to;
            }
        }

        if (command === 'registered') {
            if (client.options.nickserv) {
                var options = client.options.nickserv;
                client.say('nickserv', 'identify ' + options.account + ' ' + options.password);
            }

            network.nick = event.nick;
            state.addUser(networkid, { nick: event.nick, username: client.user.username });

            var serverBuffer = network.serverBuffer();
            state.addMessage(serverBuffer, {
                time: Date.now(),
                nick: '',
                message: TextFormatting.t('connected_to', { network: client.network.name })
            });

            client.raw('WHO ' + event.nick);

            if (network.auto_commands) {
                network.auto_commands.split('\n').forEach(function (line) {
                    state.$emit('input.raw', line[0] === '/' ? line : '/' + line);
                });
            }

            if (!network.connection.bncname) {
                network.buffers.forEach(function (buffer) {
                    if (buffer.isChannel() && buffer.enabled) {
                        client.join(buffer.name, buffer.key);
                    }
                });
            }

            requestedCh = false;
            numConnects++;
        }

        if (command === 'server options') {
            if (client.network.name !== 'Network') {
                network.name = client.network.name;
            }

            var historySupport = !!network.ircClient.network.supports('chathistory');

            if (numConnects > 1 && !requestedCh && historySupport && network.connection.bncname) {
                requestedCh = true;
                network.buffers.forEach(function (buffer) {
                    if (buffer.isChannel() || buffer.isQuery()) {
                        buffer.requestScrollback('forward');
                    }
                });
            }

            if (numConnects === 1 && !requestedCh && historySupport && network.connection.bncname) {
                requestedCh = true;
                var time = (0, _strftime2.default)('%FT%T.%L%:z', new Date());
                network.ircClient.raw('CHATHISTORY * timestamp=' + time + ' message_count=-50');
            }
        }

        if (command === 'unknown command') {
            if (event.command === '486') {
                var targetNick = event.params[1];
                var buffer = state.getOrAddBufferByName(network.id, targetNick);
                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: '*',
                    message: event.params[2],
                    type: 'error'
                });
            } else {
                var _buffer = network.serverBuffer();
                var message = '';

                if (!event.command.match(/^\d+$/)) {
                    message += event.command + ' ';
                }

                var containsNick = event.params[0] === network.ircClient.user.nick;
                var isChannelMessage = network.isChannelName(event.params[1]);

                if (containsNick && isChannelMessage) {
                    var channelBuffer = network.bufferByName(event.params[1]);
                    if (channelBuffer) {
                        _buffer = channelBuffer;
                    }
                    message += event.params.slice(2).join(', ');
                } else if (containsNick) {
                    message += event.params.slice(1).join(', ');
                } else {
                    message += event.params.join(', ');
                }

                state.addMessage(_buffer, {
                    nick: '',
                    message: message
                });
            }
        }

        if (command === 'message') {
            var isPrivateMessage = false;
            var bufferName = event.from_server ? '*' : event.target;

            if (!event.from_server && event.target === client.user.nick) {
                isPrivateMessage = true;
                bufferName = event.nick;
            }

            if (event.nick.toLowerCase() === 'chanserv' && isPrivateMessage && event.message[0] === '[') {
                bufferName = event.message.substr(1, event.message.indexOf(']') - 1);
            }

            if (event.type === 'notice') {
                var existingBuffer = state.getBufferByName(networkid, bufferName);
                if (!existingBuffer) {
                    bufferName = '*';
                }
            }

            var blockNewPms = state.setting('buffers.block_pms');
            var _buffer2 = state.getBufferByName(networkid, bufferName);
            if (isPrivateMessage && !_buffer2 && blockNewPms) {
                return;
            } else if (!_buffer2) {
                _buffer2 = state.getOrAddBufferByName(networkid, bufferName);
            }

            var textFormatType = 'privmsg';
            if (event.type === 'action') {
                textFormatType = 'action';
            } else if (event.type === 'notice') {
                textFormatType = 'notice';
            }

            var messageBody = TextFormatting.formatText(textFormatType, {
                nick: event.nick,
                username: event.ident,
                host: event.hostname,
                text: event.message
            });

            state.addMessage(_buffer2, {
                time: event.time || Date.now(),
                nick: event.nick,
                message: messageBody,
                type: event.type,
                tags: event.tags || {}
            });
        }

        if (command === 'wallops') {
            var _buffer3 = state.getOrAddBufferByName(networkid, '*');
            var _messageBody = TextFormatting.formatText('wallops', {
                text: event.message
            });

            state.addMessage(_buffer3, {
                time: event.time || Date.now(),
                nick: event.nick,
                message: _messageBody,
                type: 'wallops'
            });
        }

        if (command === 'join') {
            if (event.nick === client.user.nick) {
                network.buffers.forEach(function (b) {
                    if ((b.flags.redirect_to || '').toLowerCase() === event.channel.toLowerCase()) {
                        state.$delete(b.flags, 'redirect_to');
                        b.rename(event.channel);
                    }
                });
            }

            var _buffer4 = state.getOrAddBufferByName(networkid, event.channel);
            state.addUserToBuffer(_buffer4, {
                nick: event.nick,
                username: event.ident,
                host: event.hostname,
                realname: event.gecos
            });

            if (event.nick === client.user.nick) {
                _buffer4.enabled = true;
                _buffer4.joined = true;
                _buffer4.flags.channel_badkey = false;
                network.ircClient.raw('MODE', event.channel);
                network.ircClient.who(event.channel);
            }

            var _messageBody2 = TextFormatting.formatAndT('channel_join', null, 'has_joined', { nick: TextFormatting.formatUserFull(event) });

            state.addMessage(_buffer4, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody2,
                type: 'traffic',
                type_extra: 'join'
            });
        }
        if (command === 'kick') {
            var _buffer5 = state.getOrAddBufferByName(networkid, event.channel);
            state.removeUserFromBuffer(_buffer5, event.kicked);

            var _messageBody3 = '';

            if (event.kicked === client.user.nick) {
                _buffer5.joined = false;
                _buffer5.clearUsers();

                _messageBody3 = TextFormatting.formatAndT('channel_selfkick', { reason: event.message }, 'kicked_you_from', {
                    nick: TextFormatting.formatUser(event),
                    channel: event.channel
                });
            } else {
                _messageBody3 = TextFormatting.formatAndT('channel_kicked', null, 'was_kicked_from', {
                    nick: event.kicked,
                    channel: event.channel,
                    chanop: TextFormatting.formatUser(event.nick)
                });
            }

            state.addMessage(_buffer5, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody3,
                type: 'traffic',
                type_extra: 'kick'
            });
        }
        if (command === 'part') {
            var _buffer6 = state.getBufferByName(networkid, event.channel);
            if (!_buffer6) {
                return;
            }

            state.removeUserFromBuffer(_buffer6, event.nick);
            if (event.nick === client.user.nick) {
                _buffer6.joined = false;
                _buffer6.enabled = false;
                _buffer6.clearUsers();
            }

            var remainingBuffers = state.getBuffersWithUser(networkid, event.nick);
            if (remainingBuffers.length === 0) {
                state.removeUser(networkid, {
                    nick: event.nick
                });
            }

            var _messageBody4 = TextFormatting.formatAndT('channel_part', { reason: event.message }, 'has_left', { nick: TextFormatting.formatUserFull(event) });

            state.addMessage(_buffer6, {
                time: Date.now(),
                nick: event.nick,
                message: _messageBody4,
                type: 'traffic',
                type_extra: 'part'
            });
        }
        if (command === 'quit') {
            var buffers = state.getBuffersWithUser(networkid, event.nick);

            buffers.forEach(function (buffer) {
                if (!buffer) {
                    return;
                }

                if (event.nick === client.user.nick) {
                    buffer.joined = false;
                    buffer.clearUsers();
                }

                var messageBody = TextFormatting.formatAndT('channel_quit', { reason: event.message }, 'has_left', { nick: TextFormatting.formatUserFull(event) });

                state.addMessage(buffer, {
                    time: Date.now(),
                    nick: event.nick,
                    message: messageBody,
                    type: 'traffic',
                    type_extra: 'quit'
                });
            });

            state.removeUser(networkid, {
                nick: event.nick
            });
        }

        if (command === 'invite') {
            var _buffer7 = network.serverBuffer();
            state.addMessage(_buffer7, {
                nick: '*',
                message: TextFormatting.t('invited_you', {
                    nick: event.nick,
                    channel: event.channel
                })
            });
        }

        if (command === 'whois') {
            var obj = {
                nick: event.nick,
                host: event.hostname,
                username: event.ident,
                away: event.away || '',
                realname: event.real_name
            };

            ['actual_host', 'helpop', 'bot', 'server', 'server_info', 'operator', 'channels', 'modes', 'idle', 'logon', 'registered_nick', 'account', 'secure', 'special'].forEach(function (prop) {
                if (typeof event[prop] !== 'undefined') {
                    obj[prop] = event[prop];
                }
            });

            state.addUser(networkid, obj);
        }

        if (command === 'away') {
            state.addUser(networkid, {
                nick: event.nick,
                away: event.message || ''
            });
        }

        if (command === 'wholist') {
            state.usersTransaction(networkid, function (users) {
                event.users.forEach(function (user) {
                    var userObj = {
                        nick: user.nick,
                        host: user.hostname || undefined,
                        username: user.ident || undefined,
                        away: user.away ? 'Away' : '',
                        realname: user.real_name
                    };
                    state.addUser(networkid, userObj, users);
                });
            });
        }

        if (command === 'channel list start') {
            network.channel_list_cache = [];
            network.channel_list_state = 'updating';
        }
        if (command === 'channel list') {
            network.channel_list_state = 'updating';

            network.channel_list_cache = (network.channel_list_cache || []).concat(event);
        }
        if (command === 'channel list end') {
            network.channel_list = network.channel_list_cache || [];
            network.channel_list_state = 'updated';
            delete network.channel_list_cache;
        }

        if (command === 'motd') {
            var _buffer8 = network.serverBuffer();
            var _messageBody5 = TextFormatting.formatText('motd', {
                text: event.motd
            });
            state.addMessage(_buffer8, {
                time: event.time || Date.now(),
                nick: '',
                message: _messageBody5,
                type: 'motd'
            });
        }

        if (command === 'nick in use' && !client.connection.registered) {
            var newNick = client.user.nick + rand(1, 100);
            var _messageBody6 = TextFormatting.formatAndT('nickname_alreadyinuse', null, 'nick_in_use_retrying', { nick: client.user.nick, newnick: newNick });

            network.buffers.forEach(function (b) {
                state.addMessage(b, {
                    time: Date.now(),
                    nick: '',
                    message: _messageBody6,
                    type: 'error'
                });
            });

            client.changeNick(newNick);
        }

        if (command === 'nick in use' && client.connection.registered) {
            var _buffer9 = state.getActiveBuffer();
            _buffer9 && state.addMessage(_buffer9, {
                time: Date.now(),
                nick: '',
                type: 'error',
                message: 'The nickname \'' + event.nick + '\' is already in use!'
            });
        }

        if (command === 'nick') {
            if (event.nick === client.user.nick) {
                network.nick = event.new_nick;
            }

            state.changeUserNick(networkid, event.nick, event.new_nick);

            var _messageBody7 = TextFormatting.formatAndT('nick_changed', null, 'now_known_as', { nick: event.nick, newnick: event.new_nick });

            var _buffers = state.getBuffersWithUser(networkid, event.new_nick);
            _buffers.forEach(function (buffer) {
                state.addMessage(buffer, {
                    time: event.time || Date.now(),
                    nick: '',
                    message: _messageBody7,
                    type: 'nick'
                });
            });
        }

        if (command === 'userlist') {
            var _buffer10 = state.getOrAddBufferByName(networkid, event.channel);
            var users = [];
            event.users.forEach(function (user) {
                users.push({
                    user: {
                        nick: user.nick,
                        username: user.ident,
                        hostname: user.hostname
                    },
                    modes: user.modes
                });
            });
            state.addMultipleUsersToBuffer(_buffer10, users);
        }

        if (command === 'channel info') {
            var _buffer11 = network.bufferByName(event.channel);
            if (!_buffer11) {
                return;
            }

            if (event.modes) {
                var modeStrs = [];

                event.modes.forEach(function (mode) {
                    var adding = mode.mode[0] === '+';
                    var modeChar = mode.mode.substr(1);

                    if (adding) {
                        state.$set(_buffer11.modes, modeChar, mode.param);
                    } else if (!adding) {
                        state.$delete(_buffer11.modes, modeChar);
                    }

                    modeStrs.push(mode.mode + (mode.param ? ' ' + mode.param : ''));
                });

                if (_buffer11.flags.requested_modes) {
                    state.addMessage(_buffer11, {
                        time: event.time || Date.now(),
                        nick: '*',
                        message: _buffer11.name + ' ' + modeStrs.join(', ')
                    });
                }
            }

            if (event.created_at && _buffer11.flags.requested_modes) {
                var tFormat = _buffer11.setting('timestamp_full_format');
                var timeCreated = tFormat ? (0, _strftime2.default)(tFormat, new Date(event.created_at * 1000)) : new Date(event.created_at * 1000).toLocaleString();

                state.addMessage(_buffer11, {
                    time: event.time || Date.now(),
                    nick: '*',
                    message: _buffer11.name + ' ' + timeCreated
                });
            }
        }

        if (command === 'mode') {
            var _buffer12 = network.bufferByName(event.target);
            var _modeStrs = {};
            if (_buffer12) {
                event.modes.forEach(function (mode) {
                    _modeStrs[mode.mode] = _modeStrs[mode.mode] || [];

                    var prefix = _lodash2.default.find(network.ircClient.network.options.PREFIX, {
                        mode: mode.mode[1]
                    });

                    if (prefix) {
                        var user = state.getUser(network.id, mode.param);
                        if (user) {
                            var adding = mode.mode[0] === '+';
                            var modes = user.buffers[_buffer12.id].modes;
                            var modeIdx = modes.indexOf(prefix.mode);

                            if (adding && modeIdx === -1) {
                                modes.push(prefix.mode);
                            } else if (!adding && modeIdx > -1) {
                                modes.splice(modeIdx, 1);
                            }
                        }

                        _modeStrs[mode.mode].push({ target: mode.param });
                    } else {
                        var _adding = mode.mode[0] === '+';
                        var modeChar = mode.mode.substr(1);

                        if (_adding) {
                            state.$set(_buffer12.modes, modeChar, mode.param);
                        } else if (!_adding) {
                            state.$delete(_buffer12.modes, modeChar);
                        }

                        _modeStrs[mode.mode].push({ target: _buffer12.name, param: mode.param });
                    }
                });

                var modeLocaleIds = {
                    '+o': 'modes_give_ops',
                    '-o': 'modes_take_ops',
                    '+h': 'modes_give_halfops',
                    '-h': 'modes_take_halfops',
                    '+v': 'modes_give_voice',
                    '-v': 'modes_take_voice',
                    '+a': 'modes_give_admin',
                    '-a': 'modes_take_admin',
                    '+q': 'modes_give_owner',
                    '-q': 'modes_take_owner',
                    '+b': 'modes_gives_ban',
                    '-b': 'modes_takes_ban'
                };

                var modeLocaleDataBuilders = {
                    default: function _default(targets, mode) {
                        return {
                            mode: mode + (targets[0].param ? ' ' + targets[0].param : ''),
                            target: targets.map(function (t) {
                                return t.target;
                            }).join(', '),
                            nick: event.nick
                        };
                    },
                    b: function b(targets, mode) {
                        return {
                            target: targets[0].param ? ' ' + targets[0].param : '',
                            nick: event.nick
                        };
                    }
                };

                _lodash2.default.each(_modeStrs, function (targets, mode) {
                    var builders = modeLocaleDataBuilders;
                    var localeDataFn = builders[mode[1]] || builders.default;
                    var localeData = localeDataFn(targets, mode);

                    var prefixes = network.ircClient.network.supports('prefix') || [];
                    var isUserChanMode = !!_lodash2.default.find(prefixes, { mode: mode[1] });

                    var localeKey = isUserChanMode ? modeLocaleIds[mode] || 'modes_other' : 'modes_other';
                    var text = TextFormatting.t(localeKey, localeData);

                    var messageBody = TextFormatting.formatText('mode', {
                        nick: event.nick,
                        username: event.ident,
                        host: event.hostname,
                        target: targets.map(function (t) {
                            return t.target;
                        }).join(', '),
                        text: text
                    });
                    state.addMessage(_buffer12, {
                        time: event.time || Date.now(),
                        nick: '',
                        message: messageBody,
                        type: 'mode'
                    });
                });
            }
        }

        if (command === 'topic') {
            var _buffer13 = state.getOrAddBufferByName(networkid, event.channel);
            _buffer13.topic = event.topic || '';

            var _messageBody8 = '';

            if (event.nick) {
                _messageBody8 = TextFormatting.formatAndT('channel_topic', null, 'changed_topic_to', { nick: event.nick, topic: event.topic });
            } else {
                _messageBody8 = TextFormatting.formatText('channel_topic', event.topic);
            }

            state.addMessage(_buffer13, {
                time: event.time || Date.now(),
                nick: '',
                message: _messageBody8,
                type: 'topic'
            });
        }

        if (command === 'ctcp response' || command === 'ctcp request') {
            var _buffer14 = network.bufferByName(event.target) || network.serverBuffer();
            var textFormatId = command === 'ctcp response' ? 'ctcp_response' : 'ctcp_request';
            var _messageBody9 = TextFormatting.formatText(textFormatId, {
                nick: event.nick,
                message: event.message,
                type: event.type
            });

            state.addMessage(_buffer14, {
                time: event.time || Date.now(),
                nick: '',
                message: _messageBody9,
                type: 'error'
            });

            if (command === 'ctcp request' && event.type === 'VERSION') {
                client.ctcpResponse(event.nick, 'VERSION', 'Kiwi IRC');
            }
        }

        if (command === 'irc error') {
            var _buffer15 = void 0;
            if (event.channel) {
                _buffer15 = state.getOrAddBufferByName(network.id, event.channel);
            }
            if (!_buffer15) {
                _buffer15 = network.serverBuffer();
            }

            if (event.error === 'bad_channel_key') {
                _buffer15.flags.channel_badkey = true;
            }

            if (event.reason) {
                network.last_error = event.reason;

                var _messageBody10 = TextFormatting.formatText('general_error', {
                    text: event.reason || event.error
                });
                state.addMessage(_buffer15, {
                    time: event.time || Date.now(),
                    nick: '',
                    message: _messageBody10,
                    type: 'error'
                });
            }

            if (_buffer15.isChannel() && !_buffer15.joined) {
                _buffer15.enabled = false;
            }
        }

        next();
    }
}

function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["IrcClient"]
window._kiwi_exports.libs.IrcClient = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/IrcClient.js
// module id = jnb6
// module chunks = 1